'use strict';

const WEIGHTS_FIRST = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const WEIGHTS_SECOND = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const INVISIBLE_CHARS_REGEX = /[\u200B\u200C\u200D\uFEFF\u00A0\s]/g;
const SEPARATORS_REGEX = /[.\-/]/g;
const VALID_BODY_REGEX = /^[A-Z0-9]{12}$/;
const DIGITS_ONLY_REGEX = /^\d{2}$/;

/**
 * Converte caractere para valor numérico via ASCII-48.
 * Dígitos (0-9) → 0-9, Letras (A-Z) → 17-42
 */
function _charValue(char) {
  return char.charCodeAt(0) - 48;
}

/**
 * Calcula dígito verificador usando array de pesos.
 */
function _calcDigit(chars, weights) {
  let sum = 0;

  for (let i = 0; i < weights.length; i++) {
    sum += _charValue(chars[i]) * weights[i];
  }

  const remainder = sum % 11;

  return remainder < 2 ? 0 : 11 - remainder;
}

/**
 * Verifica se todos os 12 primeiros caracteres são iguais.
 */
function _isAllSameChar(body) {
  return body.split('').every((c) => c === body[0]);
}

/**
 * Sanitiza input de CNPJ: remove caracteres invisíveis + separadores + toUpperCase.
 * Reutilizável por outros módulos (formatters, CQRS, integrações).
 * @param {*} value - Valor a sanitizar
 * @returns {string} String limpa ou vazia se input nulo
 */
function sanitizeCnpjInput(value) {
  if (value == null) return '';

  return String(value)
    .replace(INVISIBLE_CHARS_REGEX, '')
    .replace(SEPARATORS_REGEX, '')
    .toUpperCase();
}

/**
 * Valida CNPJ numérico ou alfanumérico usando algoritmo Módulo 11 unificado.
 * @param {*} value - CNPJ a validar (com ou sem formatação)
 * @returns {boolean} true se válido
 */
function validateCnpj(value) {
  if (value == null || value === '') return false;

  const clean = sanitizeCnpjInput(value);

  if (clean.length !== 14) return false;

  const body = clean.substring(0, 12);
  const dv = clean.substring(12, 14);

  if (!VALID_BODY_REGEX.test(body)) return false;
  if (!DIGITS_ONLY_REGEX.test(dv)) return false;
  if (_isAllSameChar(body)) return false;

  const digit1 = _calcDigit(clean, WEIGHTS_FIRST);

  if (digit1 !== parseInt(dv[0], 10)) return false;

  const digit2 = _calcDigit(clean, WEIGHTS_SECOND);

  if (digit2 !== parseInt(dv[1], 10)) return false;

  return true;
}

export { validateCnpj, sanitizeCnpjInput };

export default {
  validateCnpj,
  sanitizeCnpjInput
};
